export default __webpack_public_path__ + "images/d17ac4e39b7e61e93c64bd0e66800d80.svg";